import { MouseEvent, useState } from 'react';

// eslint-disable-next-line no-restricted-imports
import { ClickAwayListener } from '@mui/material';
import { HintTooltip } from 'components/HintTooltip';
import { Stack } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Colors } from 'libs/ui/theme';

import { HintStyled, TypographyStyled } from './Hint.styles';
import { HintProps } from './types';

/**
 * Hint component.
 */
export const Hint = ({ title }: HintProps) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setOpen(true);
  };

  const preparedTitle =
    typeof title === 'string' ? (
      <TypographyStyled className="tooltip-typography" variant="caption">
        {title}
      </TypographyStyled>
    ) : (
      title
    );

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Stack alignItems="center" direction="row">
        <HintTooltip
          open={open}
          title={preparedTitle}
          onClose={handleTooltipClose}
        >
          <HintStyled onClick={handleTooltipOpen}>
            <Icon.Info className="hint-info" color={Colors.blue500} size={16} />
          </HintStyled>
        </HintTooltip>
      </Stack>
    </ClickAwayListener>
  );
};
